// HeatmapHoverCard.js — floating desktop tooltip that follows the cursor.

import React from "react";
import { Avatar, Box, Typography } from "@mui/material";
import { BRAND } from "../../theme";
import { HOME_AWAY, formatDate, orientOccurrence, parseScoreString } from "./utils";

function OccurrenceRow({ label, data, axes }) {
  if (!data) return null;
  const o = orientOccurrence(data, axes);
  return (
    <Box mb={1}>
      <Typography variant="body2" color={BRAND.violet} fontWeight="bold" mb={0.3}>
        {label}:
        <Box component="span" color={BRAND.textSecondary} ml={0.5}>
          {formatDate(data.utcDate)}
        </Box>
      </Typography>
      <Box display="flex" alignItems="center" gap={1}>
        <Avatar src={o.leftTeam?.image} sx={{ width: 18, height: 18 }} />
        <Typography variant="body2" color="#fff" noWrap>
          {o.leftTeam?.name} {o.leftScore} - {o.rightScore}{" "}
          {o.rightTeam?.name}
        </Typography>
        <Avatar src={o.rightTeam?.image} sx={{ width: 18, height: 18 }} />
      </Box>
    </Box>
  );
}

function cellTitle(key, axes) {
  const p = parseScoreString(key);
  if (axes === HOME_AWAY && p) return `Home ${p.a} – ${p.b} Away`;
  return `Score ${key}`;
}

export default function HeatmapHoverCard({ hoverData, position, axes }) {
  if (!hoverData) return null;
  return (
    <Box
      position="fixed"
      top={position.top}
      left={position.left}
      bgcolor={BRAND.surfaceStrong}
      boxShadow="0 0 10px rgba(111,93,245,0.5)"
      borderRadius={2}
      p={1.5}
      zIndex={30}
      minWidth={280}
      sx={{ pointerEvents: "none" }}
    >
      <Typography
        variant="subtitle2"
        color={BRAND.cyan}
        mb={1}
        fontWeight="bold"
      >
        {cellTitle(hoverData.key, axes)} ({hoverData.count})
      </Typography>
      <OccurrenceRow
        label="Scorigami Occurrence"
        data={hoverData.firstOccurrence}
        axes={axes}
      />
      <OccurrenceRow
        label="Latest Occurrence"
        data={hoverData.latestOccurrence}
        axes={axes}
      />
    </Box>
  );
}
